// extracted by mini-css-extract-plugin
export default {"modal":"LoginModal_modal__GtY9R","header":"LoginModal_header__RKCFd","content":"LoginModal_content__97MPv","x-btn-close":"LoginModal_x-btn-close__NkJNK"};